<template>
    <v-combobox
            ref="searchInput"
            :outlined="outline === true"
            flat
            clearable
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Motivo no encontrado' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="title"
            item-value="id"
            :label="label || 'Motivo de la cita'"
            @click:clear="clearSearch"
            return-object
            :hide-details="hideDetails === true"
    >
        <template slot="no-data" v-if="!public" >
            <span  class="caption pa-2">Motivo no encontrado:
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    depressed
                    @click="createReason">crearlo</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content>
                    <v-list-item-title>{{data.item}}</v-list-item-title>
                </v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content>
                    <v-list-item-title>{{data.item.title}}</v-list-item-title>
                </v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'outline', 'public', 'provider', 'label', 'hideDetails'],
        data(){
            return {
                descriptionLimit: 60,
                reasons: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
            },
            async createReason(){
                var vm = this

                if(vm.search.length < 3){
                    vm.showSnackBar('El motivo debe contener al menos 3 caracteres')
                    return
                }

                if(!vm.public && !vm.currentProvider){
                    throw new Error('No provider selected')
                }

                if(vm.public && !vm.provider){
                    throw new Error('No provider selected')
                }

                const provider = vm.provider || vm.currentProvider.id

                 vm.loadingCreate = true
                const prefix = vm.public === true ? 'public/' : ''
                const response = await ApiUtils.makePost(`${prefix}providers/${provider}/appointments/reason`, {
                    description: vm.search
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar el motivo')
                    return
                }

                const json = await response.json()
                vm.reasons.push(json.result.reason)
                vm.$nextTick(function(){
                    const createdModel = {
                        id: json.result.reason.id,
                        title: json.result.reason.description,
                    }
                    vm.model = createdModel
                    vm.$emit('change', createdModel)
                            vm.$nextTick(function(){
                                vm.$refs.searchInput.blur()
                            })
                })

            },
            debounceGetReasons: debounce(function(){
                this.getReasons()
            }, 300),
            async getReasons(){

                var vm = this

                if(!vm.public && !vm.currentProvider){
                    throw new Error('No provider selected')
                }

                if(vm.public && !vm.provider){
                    throw new Error('No provider selected')
                }

                const provider = vm.provider || vm.currentProvider.id

                vm.loading = true
                const prefix = vm.public === true ? 'public/' : ''
                const response = await ApiUtils.makeGet(`${prefix}providers/${provider}/appointments/reasons`, {
                    term: vm.search
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando motivos')
                    return
                }

                const json = await response.json()
                vm.reasons = json.result.reasons.data

               vm.$nextTick(function(){
                   if(vm.value){
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.reasons.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.reasons.map(reason => {
                    return {
                        id: reason.id,
                        title: reason.description,
                    }
                })
            }
        },
        watch: {
            search (val) {
                var vm = this
                if(vm.model && val === vm.model.title) return
                vm.model = null
                vm.debounceGetReasons()
            },
            value(val){
                if(!val) this.search = ''
                this.model = val
            },
            model(val){
                const newModel = typeof val === 'string' ? null : val
                this.$emit('change', newModel)
            }
        }
    }
</script>
